import getLanguage from '@/lib/utils/getLanguage';
import { filesize, type FilesizeOptions } from 'filesize';

const frenchFileSizeSymbols = {
  B: 'o',
  KB: 'Ko',
  MB: 'Mo',
  GB: 'Go',
  TB: 'To',
} satisfies FilesizeOptions['symbols'];

let filesizeConfig: FilesizeOptions | null = null;

const initFilesizeConfig = (): void => {
  const language = getLanguage();

  filesizeConfig = {
    standard: 'jedec',
    locale: language,
  };

  if (language === 'fr') {
    filesizeConfig.symbols = frenchFileSizeSymbols;
  }
};

const formatFileSize = (fileSize: number): string => {
  if (filesizeConfig === null) {
    initFilesizeConfig();
  }

  return filesize(fileSize, filesizeConfig!);
};

export default formatFileSize;
